import { Button, FormControlLabel, Switch, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { changeStatusCustomer, deleteCustomer, getAllCustomers } from "../../../../api/customer";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";

function getData(customers) {
  return customers
    .map((customer) => ({
      fullName: customer.fullName,
      nif: customer.nif,
      createdAt: customer.createdAt,
      id: customer._id,
      active: customer.active,
    }));
}

const initialFilters = {
  active: false,
};


export default function CustomersPage() {
  const rolePath = useLocation().pathname.split("/")[1];
  const rolePathUpperCase = rolePath.charAt(0).toUpperCase() + rolePath.slice(1);
  const rolePathSingle = rolePath.slice(0, -1);


  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refresh, setRefresh] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);

  const [customer, setCustomer] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterOptions, setFilterOptions] = useState(initialFilters);


  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push(`/edit-${rolePathSingle}/${elem.id}`)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            {<Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCustomer(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>}
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCustomer(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "fullName", text: "Legal name", sort: true },
    { dataField: "nif", text: "NIF", sort: true },
    {
      dataField: "createdAt",
      text: "Created at",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getAllCustomers(rolePathSingle)
      .then((res) => {
        const data = getData(res.data)
        setData(data);
        setFilteredData(data);
        setRefresh(false);
      })
      .catch((error) => {
        alertError({ error, customMessage: `Could not get ${rolePath}.` });
      });
  }, [refresh, rolePath, rolePathSingle]);

  const handleSearch = () => {
    if (!data.length)
      return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active)
          filter = filter && item.active;
        return filter;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => (
    <>
      <br />
      <FormControlLabel
        control={
          <Switch
            checked={filterOptions.active}
            onChange={() =>
              setFilterOptions({
                ...filterOptions,
                active: !filterOptions.active,
              })
            }
            name="checkActive"
          />
        }
        label={filterOptions.active ? "Only active" : "All active/inactive"}
      />
    </>
  );

  return (
    <Card>
      <CardHeader title={`${rolePathUpperCase} list`}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => history.push(`/edit-${rolePathSingle}`)}
          >
            Add new
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/*<FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />*/}

        <Table key={data.length} data={filteredData} columns={columns} />

        <ConfirmDialog
          title={`Are you sure you want to ${customer?.active ? "disable" : "enable"
            } this ${rolePathSingle}?`}
          open={openConfirmDialog === 1}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            changeStatusCustomer(customer.id, !customer?.active)
              .then((res) => {
                alertSuccess({
                  title: `${customer?.active ? "Disabled!" : "Enabled!"}`,
                  customMessage: `Seller ${customer?.active ? "disabled" : "enabled"
                    } successfully`,
                });
                setRefresh(true);
              })
              .catch((error) => {
                alertError({
                  error,
                  customMessage: `Could not ${customer?.active ? "disable" : "enable"
                    } ${rolePathSingle}.`,
                });
              });
          }}
        />
        <ConfirmDialog
          title={`Are you sure you want to remove this ${rolePathSingle}?`}
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteCustomer(customer.id)
              .then((res) => {
                alertSuccess({
                  title: "Deleted!",
                  customMessage: `${rolePathUpperCase} removed successfully.`,
                });
                setRefresh(true);
              })
              .catch((error) => {
                alertError({
                  error,
                  customMessage: `Could not remove ${rolePathSingle}`,
                });
              });
          }}
        />
      </CardBody>
    </Card>
  );
}